import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OutcomeJson } from '@core/models/built/session-step-value-json.model';
import { SessionStepValueType } from '@core/models/built/session-step-value-type.enum';
import { SessionStep, SessionStepValue } from '@core/models/session.model';
import { filterTruthy } from '@utils';
import { DateTime } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './outcome-session.component.html',
})
export class OutcomeSessionComponent implements OnChanges {
  @Input() step!: SessionStep;

  @Output() commitAndNext = new EventEmitter<SessionStep>();

  private step$$ = new BehaviorSubject<SessionStep | undefined>(undefined);
  step$ = this.step$$.pipe(filterTruthy());

  outcomeValue$ = this.step$.pipe(
    map((step) => {
      if (step.values && step.values[0]) {
        return step.values[0].value as OutcomeJson;
      } else {
        return undefined;
      }
    })
  );

  inputForm: FormGroup = this.fb.group({
    value: [undefined, [Validators.required]],
  });

  constructor(private fb: FormBuilder) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

  submit() {
    if (this.step.values && this.step.values[0]) {
      const existingValue = this.step.values[0].value as OutcomeJson;
      const now = DateTime.local().toJSDate();
      const value: SessionStepValue = {
        workflowId: this.step.workflowId,
        workflowStepId: this.step.workflowStepId,
        sessionId: this.step.sessionId,
        timestamp: now,
        type: SessionStepValueType.outcome,
        value: { ...existingValue, viewed: true },
      };
      this.commitAndNext.emit({ ...this.step, completedOn: now, values: [value] });
    }
  }
}
